import moment from "moment";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";

export default function Timeline() {
  const defaultColumns: any = [
    {
      header: "Date",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>
              {moment(getValue()).format("YYYY-MM-DD")}
            </p>
          </>
        );
      },
    },
    {
      header: "Time",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>
              {moment(getValue()).format("HH:mm:ss")}
            </p>
          </>
        );
      },
    },
    {
      header: "Day",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{moment(getValue()).format("dddd")}</p>
          </>
        );
      },
    },
    {
      header: "Platform",
      accessorKey: "platform",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`capitalize`}> {getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "User Agent",
      accessorKey: "browser",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`capitalize`}> {getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
  ];

  return (
    <DataTable
      url={APIS.LOGIN_HISTORY}
      queryKey={"login-history"}
      columns={defaultColumns}
      tableName={"Login History"}
    />
  );
}
